import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { useDefaultCurrency } from "@/routes/_layout/quoting_/quotes/-lib/default-currency"
import {
  savedMessage,
  TaskPanel,
} from "@/routes/_layout/templates/-components/task-panel"

export const Route = createFileRoute(
  "/_layout/templates/quotes_/$packageId/_list/tasks/create",
)({
  staticData: { detailSidebar: true },
  component: CreateTemplateQuoteTask,
})

function CreateTemplateQuoteTask(): React.ReactElement | null {
  const { packageId } = Route.useParams()
  const currency = useDefaultCurrency()
  const navigate = useNavigate()
  const showToast = useCustomToast()

  if (currency === undefined) return null

  return (
    <TaskPanel
      task={null}
      currency={currency}
      onSaved={(saved) => {
        showToast("Created", savedMessage(saved), "success")
        void navigate({
          to: "/templates/quotes/$packageId/tasks/$taskId",
          params: { packageId, taskId: saved.id },
          search: true,
          replace: true,
        })
      }}
      onClose={() =>
        navigate({
          to: "/templates/quotes/$packageId",
          params: { packageId },
          search: true,
        })
      }
    />
  )
}
